export const EARLY_ACCESS = "EARLY_ACCESS";
export const getEarlyAccess = (data) => {
    return {
        type: EARLY_ACCESS,
        payload:data
    }
}